import { useEffect, useState } from 'react';

/** The build-time prerender (scripts/prerender.js) drives headless Chrome. */
export function isPrerenderer(userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent) {
  return /HeadlessChrome/.test(userAgent);
}

/**
 * Renders children only after mount and never in the prerenderer, so per-visitor
 * UI (the cookie banner) stays out of the prerendered HTML.
 */
export default function ClientOnly({ children }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    if (!isPrerenderer()) setMounted(true);
  }, []);
  return mounted ? children : null;
}
